import React from "react";
import { useField } from "formik";
import { FUND_PARSE_DATE_HELP } from "./fundParseDefaults";

interface FundParseDateFieldProps {
    disabled: boolean;
}

export function FundParseDateField({ disabled }: FundParseDateFieldProps): React.ReactElement {
    const [field, meta] = useField("date");

    return (
        <div className="mb-4 w-full min-w-0">
            <label htmlFor="date" title={FUND_PARSE_DATE_HELP} className="cursor-help border-b border-dotted border-gray-400">
                Date
            </label>
            <input
                id="date"
                type="text"
                className="form-input"
                disabled={disabled}
                title={FUND_PARSE_DATE_HELP}
                {...field}
                value={field.value || ""}
            />
            {meta.error ? <div className="form-field-error">{meta.error}</div> : null}
        </div>
    );
}
